export const LOADER_TEST_ID = 'loader'
export const ERROR_TEST_ID = 'error'
export const CREATE_LIST_TEST_ID = 'create-list'
